export default __webpack_public_path__ + "static/media/cpr-demo.d5531151.png";